<template>
  <div class="px-4 py-1.5 w-full flex items-center gap-4 bg-brand-black-autofill">
    <a
      v-if="!enableUaePassSingleSignOn || !impersonateUserManagmentPortal"
      :href="userManagmentUrl"
      target="_blank"
      class="flex gap-x-2 text-white"
    >
      <faArrowUpRightFromSquare class="w-4 fill-white" />
      {{ $t('usersManagment') }}
    </a>
    <button
      v-if="enableUaePassSingleSignOn && impersonateUserManagmentPortal"
      class="flex gap-x-2 text-white"
      @click="goToSecurityPortal"
    >
      <faArrowUpRightFromSquare class="w-4 fill-white" />
      {{ $t('usersManagment') }}
    </button>
    <a
      v-if="!enableUaePassSingleSignOn || !impersonateAmwalPortal"
      :href="amwalPortalUrl"
      target="_blank"
      class="flex gap-x-2 text-white"
    >
      <faArrowUpRightFromSquare class="w-4 fill-white" />
      {{ $t('amwalPortal') }}
    </a>
  </div>
</template>

<script setup>
import faArrowUpRightFromSquare from '@/assets/icons/faArrowUpRightFromSquare.svg?component'
import client_config from '@/assets/json/client_config.json'
import axiosInstance from '@/services'
import { useEstablishmentStore } from '@/stores/establishment.js'
import { onMounted, ref } from 'vue'

const { amwalPortalUrl, userManagmentUrl } = client_config

const establishmentStore = useEstablishmentStore()

const relatedUAEPassConfig = ref({})

onMounted(async () => {
  if (!establishmentStore.uaePassConfig) {
    await establishmentStore.getUAEPassSetup()

    const { enableUaePassSingleSignOn, impersonateUserManagmentPortal, impersonateAmwalPortal } =
      establishmentStore.uaePassConfig

    Object.assign(relatedUAEPassConfig.value, {
      enableUaePassSingleSignOn,
      impersonateUserManagmentPortal,
      impersonateAmwalPortal
    })
  }
})

async function goToSecurityPortal() {
  const response = await axiosInstance.get('/api/user/security/impersonateLogin/token')
  const url = `${userManagmentUrl}&idToken=${response.token}`
  window.open(url, '_blank')
}
</script>

<style lang="scss" scoped></style>
